<template>
  <div class="target_flow">
    <div class="drop_box fl" :class="{'must': mode === 'cpmL'}">
      <el-dropdown size="mini" @command="handleCommand">
        <span>{{ curItem.name }}<i class="el-icon-caret-bottom el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown" class="flow-dropdown">
          <el-dropdown-item
            v-for="each in labelList"
            :key="each.code"
            :command="each"
            :class="{'cur': curItem == each}">
            {{ each.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="right">
      <el-input :placeholder="curItem.placeholder" v-model="inputV" size="mini" @keyup.native="handleChange">
        <i slot="append">{{ curItem.append }}</i>
      </el-input>
    </div>
  </div>
</template>

<script>
const allConfig = {
  'M1': { placeholder: '请输入', append: '千人次' }, // 触达总量
  'M2': { placeholder: '请输入', append: '千人次' } // 精准流量
}

export default {
  name: 'TargetFlowSelect',
  props: {
    mode: {
      type: String
    },
    isImport: {
      type: Boolean
    }
  },
  data() {
    return {
      curItem: {
        label: '', placeholder: '', append: '', value: ''
      },
      timeOut: null,
      inputV: ''
    }
  },
  computed: {
    labelList() {
      const list = this.$store.state.label.sortMap['TARGET'] || []
      // 导入小区或点位 只有触达总量选项
      const config = this.isImport ? { 'M1': { placeholder: '请输入', append: '千人次' } } : allConfig
      return list.filter(e => config[e.code]).map(t => ({ ...t, ...config[t.code] }))
    }
  },
  watch: {
    curItem: {
      deep: true,
      handler (v, ov) {
        this.emitInput()
      }
    },
    inputV() {
      this.emitInput()
    }
  },
  mounted() {
    if (this.labelList && this.labelList.length) {
      this.curItem = this.labelList[0]
    }
  },
  beforeDestroy() {
    // 外部状态会出现此组件的不存在 导致此组件外部数据依然存在
    // 此处组件销毁前 改变外部数据状态
    this.$emit('input', {
      targetFlowOrbudgetAmount: '', chooseLabel: []
    })
  },
  methods: {
    emitInput() {
      this.$emit('input', {
        targetFlowOrbudgetAmount: this.inputV.trim(), chooseLabel: [this.curItem.code]
      })
    },
    handleChange(e) {
      if (!this.timeOut) {
        this.timeOut = setTimeout(() => {
          clearTimeout(this.timeOut)
          this.timeOut = null
          let v = e.target.value
          let trimV = v.trim() - 0
          if (v === '' || isNaN(trimV) || trimV - 0 < 0) {
            this.curItem.value = ''
            this.inputV = ''
          } else {
            this.curItem.value = trimV + ''
          }
        }, 200)
      }
    },
    handleCommand(data) {
      // 重置输入内容
      this.curItem.value = ''
      this.curItem = data
      this.inputV = ''
    }
  }
}
</script>

<style lang="sass" scoped>
.flow-dropdown
  width: 90px
  border: 1px solid #282729
  padding: 10px 8px
  transform: translate(20px, 10px)
  li
    line-height: 30px
    color: #282729
    font-size: 14px
    padding: 0
    text-align: center
    &:hover, &.cur
      font-weight: bold
      color: #FF3973
      background: none
  ::v-deep .popper__arrow
    display: none

.target_flow
  border: 1px solid #e9e9e9
  border-radius: 4px
  height: 40px
  margin-bottom: 20px
  padding: 9px 0
  line-height: 20px
  position: relative
  .drop_box
    cursor: pointer
    position: relative
    width: 87px
    border-right: 1px solid #e9e9e9
    margin-right: 10px
    text-align: right
    padding-right: 18px
    &.must::before
      content: "*"
      position: absolute
      left: 5px
      top: 1px
      color: #FF3973
    ::v-deep .el-dropdown
      color: #282729
      font-weight: 600
      .el-icon--right
        position: absolute
        right: -12px
        top: 4px
    ::v-deep .el-dropdown-menu
      font-weight: 600
  .right
    position: absolute
    width: calc(100% - 100px)
    // width: 120px
    right: 0
    top: 5px
    ::v-deep .el-input
      width: 120px
      input
        width: 100px
        padding-left: 0
        border: none
      .el-input-group__append
        border: none
        background: none
    ::v-deep .el-input-number
      > span
        display: none
      .el-input
        width: auto
        input
          text-align: left
          padding-right: 0

</style>
